import React from 'react';
interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  dark?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  dark = false
}: SectionHeadingProps) {
  return <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-227" data-mp="3jzx4bzvre8pe">
      <p className="text-gold uppercase tracking-[0.4em] text-xs mb-4" data-id="element-228" data-mp="bkdi3kti9qju">{eyebrow}</p>
      <h2 className={`font-serif text-4xl sm:text-5xl leading-tight ${dark ? 'text-paper' : 'text-ink'}`} data-id="element-229" data-mp="bmpulighv8pi">
        {title}
      </h2>
      <div className={`mt-5 h-px w-16 bg-gold ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-230" data-mp="1u0wrqdv9tcn" />
      {description && <p className={`mt-6 text-lg leading-relaxed ${dark ? 'text-paper/70' : 'text-ink/65'}`} data-id="element-231" data-mp="6raiauy4xkv7">
          {description}
        </p>}
    </div>;
}